module.exports = __webpack_public_path__ + "img/login-no-bg.82a7e7b1.png";